import Vue from "vue";
import App from "./App.vue";
import antdImport from "./antdImport";
import { message, Modal } from "ant-design-vue";

import store from "./store";
import router from "./router";

import "perfect-scrollbar/css/perfect-scrollbar.css";

Vue.config.productionTip = false;
Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;

antdImport();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
